import { Center, Stack, Text, useColorMode, Box } from "@chakra-ui/react";
import useCustomTranslation from "../hooks/useCustomTranslation";
import { motion } from "framer-motion";

// 👇 SVGR import
// import { ReactComponent as MySVG } from "./crisps_final_really_fixed.svg";
import LogoWhite from "./images/logoWhite";
import LogoBlack from "./images/logoBlack";

// 👇 Wrap SVG component in motion
// const MotionSVG = motion(MySVG);

export const Loading = () => {
  const { t } = useCustomTranslation();
  const { colorMode } = useColorMode();

  return (
    // <Center h="100dvh">
      <Stack alignContent="center" justifyItems="center">
        <Box p="4" borderRadius="md" w="300px" h="300px">
          {colorMode === "light" ? <LogoBlack /> : <LogoWhite/> }
        </Box>
        {/* <Text>{t("Loading")}</Text> */}
      </Stack>
    // </Center>
  );
};
